<template>
  <div class="logo-wrapper">
    <slot name="logo" />
  </div>
</template>

<style lang="scss" scoped>
.logo-wrapper {
  padding-left: 14px;
  padding-right: 16px;
  display: inline-flex;
}
</style>
